import { AttributeValue } from "../../../../library-js/dom-tools/AttributeValue";
import { ElementAttribute } from "../../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../../library-js/dom-tools/EventListeners";
import { Link, LinkType } from "../../../../library-js/dom-tools/LinkResolver";
import { ContextMenu } from "../../../../library-templates/context--menu/ContextMenu";
import { ContextMenuCreator } from "../../../../library-templates/context--menu/ContextMenuCreator";
import { Rokojori } from "../../Rokojori";
import { HeaderMenu } from "../HeaderMenu";
import { LinkContextEntry } from "../LinkContextMenuEntry";


export class Projects_en extends ContextMenuCreator
{
  static value = new AttributeValue( ContextMenuCreator.attribute, "projects-en" );
  
  get value(){ return Projects_en.value }
  
  create( e:Element ):ContextMenu
  {
    let entries:LinkContextEntry[] =
    [ 
      { label:"Projects Overview", link:"::/en/projects" }, 
      { label:"Dash Cup Kickers", link:"::/en/dash-cup-kickers/index.php" },
      { label:"Rokojori Radio", link:"::/en/radio/index.php" },
      { label:"Calculator", link:"::/en/apps/calculator" }
    ];

    return HeaderMenu.create( "Labs", entries );
  }
}